<template>
  <b-tab :title="$t('Synchronization Log')">
    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :search="tableData.search" :fields="tableFields"
                   :enable-simple-search="false" export-vuex-module-name="bidders"
                   export-permission-name="export_auction" @paramsChanged="getTableData"
                   filter-toggle-string="accounting-table" v-if="tableData">
      <template v-slot:search-form-placeholder>
        <search-collapse table-id="accounting-table">
          <accounting-search :update-search-model="updateSearchModel" :get-table-data="getTableData"
                             :vuex-search-model="tableData.searchModel"/>
        </search-collapse>
      </template>

      <template slot="cell(started_at)" slot-scope="{item}">
        {{ item.started_at | toDateTime }}
      </template>
      <template slot="cell(completed_at)" slot-scope="{item}">
        <span v-if="item.completed_at">
          {{ item.completed_at | toDateTime }}
        </span>
      </template>
      <template slot="cell(status)" slot-scope="{item}">
        <span v-as-status="item.status">
          {{ item.status | removeUnderscores | toUpperCaseEveryWord }}
        </span>
      </template>
      <template slot="cell(sale_no)" slot-scope="{item}">
        <span v-if="item.auction">
          {{ item.auction.sale_no }}
        </span>
      </template>
      <template slot="cell(object_type)" slot-scope="{item}">
        {{ item.object_type | removeUnderscores | toUpperCaseEveryWord }}
      </template>
      <template slot="cell(actions)" slot-scope="{item}">
        <div>
          <b-tooltip :target="`view-btn-${item.uuid}`" :title="$t('View Info')"/>
          <b-button v-if="item.errors && item.object_type !== 'payment'" size="sm" variant="primary" :id="`view-btn-${item.uuid}`"
                    @click="onViewInfoClick(item)">
            <font-awesome-icon icon="eye"/>
          </b-button>

          <b-tooltip :target="`errors-btn-${item.uuid}`" :title="$t('View Errors')"/>
          <b-button v-if="item.errors" size="sm" variant="danger" :id="`errors-btn-${item.uuid}`"
                    @click="onViewErrorsClick(item)" class="ml-2">
            <font-awesome-icon icon="exclamation-circle"/>
          </b-button>
        </div>
      </template>
    </artisio-table>

  </b-tab>
</template>

<script>
  import i18n from "@/shared/i18n";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import SearchCollapse from "@/core/components/search-collapse/SearchCollapse";
  import AccountingSearch from "@/modules/setup/accounting/AccountingSearch";

  const {mapActions, mapState} = createNamespacedHelpers('setup/accounting');

  export default {
    name: "AccountingSyncTable",
    components: {AccountingSearch, SearchCollapse, ArtisioTable},
    methods: {
      ...mapActions(['getTableData', 'updateTableSource', 'updateSearchModel']),
      onViewInfoClick(log) {
        let arr;
        let msg;

        if (log.object_type === 'settlement') {
          msg = this.$i18n.t("Synchronized Settlement Numbers")
          arr = log.settlement_numbers;
        } else if (log.object_type === 'invoice') {
          msg = this.$i18n.t("Synchronized Invoice Numbers")
          arr = log.invoice_numbers;
        } else if (log.object_type === 'receipt') {
          msg = this.$i18n.t("Synchronized Receipt Numbers")
          arr = log.receipt_numbers;
        } else if (log.object_type === 'customer') {
          msg = this.$i18n.t("Synchronized Customer Numbers")
          arr = log.customer_numbers;
        } else if (log.object_type === 'payment') {
          arr = null;
        }

        if (arr) {
          const listItemsArr = [];
          arr.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
          this.$errorDialog(
            this.$createElement('ul', {class: "mb-0"}, listItemsArr),
            msg,
            {headerBgVariant: "primary", okVariant: "primary"}
          );
        }
      },
      onViewErrorsClick(log) {
        let errorData = [];
        for (let item of log.errors) {
          Object.keys(item).forEach(key => {
            let errorMessage;
            if (key === "non_field_errors") {
              errorMessage = this.$i18n.t(item[key]);
            } else {
              errorMessage = this.$i18n.t("{object_type}: {no}. Error: {error}", {
                no: key,
                error: item[key],
                object_type: log.object_type
              });
            }
            errorData.push(errorMessage);
          })
        }
        const listItemsArr = [];
        errorData.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
        this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t("Errors on {object_type} synchronization", {object_type: log.object_type}));
      }
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource],
      }),
      tableFields() {
        return [
          {key: "object_type", label: i18n.t('Type'), sortable: true, tdClass: 'object-type-col'},
          {key: "status", label: i18n.t('Status'), sortable: true, tdClass: 'status-col'},
          {key: "started_at", label: i18n.t('Start Date'), sortable: true, tdClass: 'started-at-col'},
          {key: "completed_at", label: i18n.t('Completion Date'), sortable: true, tdClass: 'started-at-col'},
          {key: "failed_count", label: i18n.t('Failed'), sortable: true, tdClass: 'started-at-col'},
          {key: "success_count", label: i18n.t('Successful'), sortable: true, tdClass: 'started-at-col'},
          {key: "sale_no", label: i18n.t('Sale No'), sortable: false, tdClass: 'sale-no-col'},
          {key: "actions", label: i18n.t('Actions'), sortable: false, tdClass: 'started-at-col'},
        ]
      },
    },
    async mounted() {
      await this.updateTableSource({source: 'accounting'})
      this.getTableData();
    }
  }
</script>

<style scoped>

</style>